export const SERVICE_PERFORMANCE_LOAD_SERVICES = 'SERVICE_PERFORMANCE/LOAD_SERVICES'
export const SERVICE_PERFORMANCE_LOAD_SITE_SERVICES = 'SERVICE_PERFORMANCE/LOAD_SITE_SERVICES'
export const SERVICE_PERFORMANCE_LOAD_TIME_RANGES = 'SERVICE_PERFORMANCE/LOAD_TIME_RANGES'
export const SERVICE_PERFORMANCE_LOAD_SITES = 'SERVICE_PERFORMANCE/LOAD_SITES'
export const SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL = 'SERVICE_PERFORMANCE/LOAD_SERVICE_DETAIL'
export const SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_INT =
  'SERVICE_PERFORMANCE/LOAD_SERVICE_DETAIL_INT'
export const SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_GRAPH =
  'SERVICE_PERFORMANCE/LOAD_SERVICE_DETAIL_GRAPH'
export const SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA = 'SERVICE_PERFORMANCE/LOAD_SITES/MAP_DATA'
export const SERVICE_PERFORMANCE_LOAD_SITES_SUMMARY = 'SERVICE_PERFORMANCE/LOAD_SITES_SUMMARY'
export const SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY = 'SERVICE_PERFORMANCE/LOAD_SERVICES_SUMMARY'
export const SERVICE_PERFORMANCE_PUT_REFERENCE = 'SERVICE_PERFORMANCE/PUT_REFERENCE'
export const SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE = 'SERVICE_PERFORMANCE/PUT_SERVICE_REFERENCE'
export const SERVICE_PERFORMANCE_LOAD_SERVICE_FILTERS = 'SERVICE_PERFORMANCE_LOAD_SERVICE_FILTERS'
export const SERVICE_PERFORMANCE_LOAD_PLANNED_MAINTENANCE_SUMMARY =
  'SERVICE_PERFORMANCE/LOAD_PLANNED_MAINTENANCE_SUMMARY'
export const INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SERVICE =
  'INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SERVICE'
export const SERVICE_PERFORMANCE_LOAD_SERVICES_INT = 'SERVICE_PERFORMANCE_LOAD_SERVICES_INT'
export const YOUR_SERVICES_INT_DOWNLOAD_CSV = 'YOUR_SERVICES_INT_DOWNLOAD_CSV'
export const SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT =
  'SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT'
export const SERVICE_PERFORMANCE_LOAD_SERVICES_AUTO_INT =
  'SERVICE_PERFORMANCE_LOAD_SERVICES_AUTO_INT'
export const SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT =
  'SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT'
export const INVENTORY_INTERNATIONAL_UPDATE_FILTER_COMPANIES =
  'INVENTORY_INTERNATIONAL_UPDATE_FILTER_COMPANIES'
export const INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SITES =
  'INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SITES'
export const INVENTORY_INTERNATIONAL_UPDATE_COMBINE_TAGS_SERVICE =
  'INVENTORY_INTERNATIONAL_UPDATE_COMBINE_TAGS_SERVICE'
export const USER_MANAGEMENT_GET_USER_DYNAMIC = 'USER_MANAGEMENT_GET_USER_DYNAMIC'
export const SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_INT_BY_CIDN =
  'SERVICE_PERFORMANCE/LOAD_SERVICE_DETAIL_INT_BY_CIDN'
export const SERVICE_PERFORMANCE_LOAD_IP_SERVICES_INT = 'SERVICE_PERFORMANCE_LOAD_IP_SERVICES_INT'
export const SERVICE_PERFORMANCE_DELETE_PREFIX_SERVICES_INT =
  'SERVICE_PERFORMANCE_DELETE_PREFIX_SERVICES_INT'
export const NETWORK_PREFIX_SERVICES_INT_DOWNLOAD_CSV = 'NETWORK_PREFIX_SERVICES_INT_DOWNLOAD_CSV'
export const SERVICE_PERFORMANCE_SUBMIT_PREFIX_SERVICES_INT =
  'SERVICE_PERFORMANCE_SUBMIT_PREFIX_SERVICES_INT'
export const SERVICE_PERFORMANCE_VALIDATE_PREFIX_SERVICE_INT =
  'SERVICE_PERFORMANCE_VALIDATE_PREFIX_SERVICE_INT'
export const SERVICE_PERFORMANCE_LOAD_COMPANY = 'SERVICE_PERFORMANCE_LOAD_COMPANY'
export const LOAD_NETWORK_PERFORMANCE_REPORTS = 'LOAD_NETWORK_PERFORMANCE_REPORTS'
export const LOAD_NP_REPORTS_URL = 'LOAD_NP_REPORTS_URL'
export const SERVICE_AS_SET_OBJECT = 'SERVICE_AS_SET_OBJECT'
export const SERVICE_PERFORMANCE_LOAD_DNS_SERVICES_INT = 'SERVICE_PERFORMANCE_LOAD_DNS_SERVICES_INT'
export const SERVICE_PERFORMANCE_DELETE_DOMAIN_SERVICES_INT =
  'SERVICE_PERFORMANCE_DELETE_DOMAIN_SERVICES_INT'
export const SERVICE_PERFORMANCE_DELETE_DNS_SERVICES_INT =
  'SERVICE_PERFORMANCE_DELETE_DNS_SERVICES_INT'
export const REVERSE_DNS_SERVICES_INT_DOWNLOAD_CSV = 'REVERSE_DNS_SERVICES_INT_DOWNLOAD_CSV'
export const SERVICE_PERFORMANCE_SUBMIT_DNS_SERVICES_INT =
  'SERVICE_PERFORMANCE_SUBMIT_DNS_SERVICES_INT'
export const SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT =
  'SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT'
export const SERVICE_LOAD_SERVICE_LIST_FILTER_INT = 'SERVICE_LOAD_SERVICE_LIST_FILTER_INT'
export const INVENTORY_INTERNATIONAL_UPDATE_GROUP_BY_SERVICE =
  'INVENTORY_INTERNATIONAL_UPDATE_GROUP_BY_SERVICE'
export const UPDATE_SERVICES_USER_REFERENCE = 'UPDATE_SERVICES_USER_REFERENCE'
